import React, { FC } from 'react';

interface IProps {
  title: string;
  description: string;
  items: { title: string; description: string }[];
  footerText: string;
}

export const ContentWhat: FC<IProps> = ({
  title,
  description,
  items,
  footerText,
}) => {
  return (
    <div>
      <h3 className="mb-6 text-left text-4xl font-semibold">{title}</h3>
      <p className="mb-10 text-left text-lg font-normal">{description}</p>
      <ul className="mb-13 ml-6 list-disc">
        {items.map((item) => (
          <li className="mb-6 text-left" key={item.title}>
            <span className="text-left font-semibold">{item.title} </span>
          </li>
        ))}
      </ul>
      <p
        className="description-with-links text-left font-medium"
        dangerouslySetInnerHTML={{ __html: footerText }}
      />
    </div>
  );
};
